import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { SubHeadResponse } from '@cosvision/shared';
import { listSubHeadsByFund, type ListSubHeadsOptions } from '../lib/api/sub-heads.js';
import { qk } from '../lib/query-keys.js';

export function useSubHeadsQuery(
  fundId: string | null | undefined,
  opts: ListSubHeadsOptions = {},
): UseQueryResult<SubHeadResponse[]> {
  return useQuery({
    queryKey: qk.subHeads.listByFund(fundId ?? '', opts),
    queryFn: () => listSubHeadsByFund(fundId as string, opts),
    enabled: typeof fundId === 'string' && fundId.length > 0,
  });
}
